//格式化这类2020/10/18或2020-10-18或'2020/10/18 10:20:10'或'2020年10月18日 10时20分10秒'为--时间截或 new Date()日期格式
function formatGetTime(txt,date){  //参数2为 date === 'Date'时,输出为非时间截
  const arr = txt.match(new RegExp(/[0-9]{1,4}/,"gi"))
  let save
  switch(arr.length){
    case 1 :
      save = `${arr[0]}/01/01`
      break;
    case 2 :
      save = `${arr[0]}/${arr[1]}/01`
      break;
    case 3 :
      save = `${arr[0]}/${arr[1]}/${arr[2]}`
      break;
    case 4 :
      save = `${arr[0]}/${arr[1]}/${arr[2]} ${arr[3]}:00:00`
      break;
    case 5 :
      save = `${arr[0]}/${arr[1]}/${arr[2]} ${arr[3]}:${arr[4]}:00`
      break;
    default :
      save = `${arr[0]}/${arr[1]}/${arr[2]} ${arr[3]}:${arr[4]}:${arr[5]}`
  }
  if(date === 'Date'){
    return new Date(save)
  }else{
    return new Date(save).getTime()
  }
}
export default formatGetTime;


// WEBPACK FOOTER //
// ./src/commons/my-plug/formatGetTime.js